import(/* webpackMode: "eager" */ "/vercel/path0/app/featured/page.tsx");
